import endpoints from "static/endpoints";
import api from "app/lib/api";
import { interpolate } from "utils/string";

export const getLetterTemplates = async (patientId) => {
  let url = interpolate(endpoints.letter_templates.fetchLetterTemplates, {
    patientId,
  });
  const response = await api.get(url);
  return response;
};

export const getAllLetterTemplates = async () => {
  let url = endpoints.letter_templates.fetchAllLetterTemplates;
  const response = await api.get(url);
  return response;
};

export const fetchAllLetterContentTemplate = async () => {
  let url = endpoints.letter_templates.fetchAllLetterContentTemplate;
  const response = await api.get(url);
  return response;
};

export const generateLetterTemplate = async (payload) => {
  let url = endpoints.letter_templates.generateLetterTemplate;
  const response = await api.post(url, payload);
  return response;
};

export const saveLetterTemplate = async (payload) => {
  let url = endpoints.letter_templates.saveLetterTemplate;
  const response = await api.post(url, payload);
  return response;
};

export const getNoShowLetterTemplates = async (patientId) => {
  if (!patientId) {
    return;
  }
  let url = interpolate(endpoints.noShowLetter.fetchNoShowLetters, {
    patientId,
  });
  const response = await api.get(url);
  return response;
};

export const generateNoShowLetter = async (payload) => {
  let url = endpoints.noShowLetter.generateNoShowLetter;
  const response = await api.post(url, payload);
  return response;
};

export const sendNoShowEmail = async (payload) => {
  let url = endpoints.noShowLetter.sendNoShowEmail;
  const response = await api.post(url, payload);
  return response;
};

export const getLetterNextSend = async (payload) => {
  const { patientId, templateId } = payload;
  let url = `${endpoints.letter_templates.getLetterNextSend}?patientId=${patientId}&templateId=${templateId}`;
  const response = await api.get(url, payload);
  return response;
};

export const createLetterTemplate = async (payload) => {
  let url = endpoints.letter_templates.createLetterTemplate;
  const response = await api.post(url, payload);
  return response;
};

export const updateLetterTemplate = async (payload, templateId) => {
  let url = interpolate(endpoints.letter_templates.updateLetterTemplate, {
    templateId,
  });
  const response = await api.patch(url, payload);
  return response;
};

export const archiveLetterTemplate = async (templateId) => {
  let url = interpolate(endpoints.letter_templates.archiveLetterTemplate, {
    templateId,
  });
  const response = await api.patch(url);
  return response;
};

export const updateLetterTemplateStatus = async (templateId, status) => {
  let url = interpolate(endpoints.letter_templates.updateLetterTemplateStatus);
  const response = await api.patch(url, { templateId, status });
  return response;
};

export const deleteLetterTemplate = async (templateId) => {
  let url = interpolate(endpoints.letter_templates.letterTemplateById, {
    templateId,
  });
  const response = await api.delete(url);
  return response;
};
